/* =========================================================
   UNISOURCE DESIGN INSPIRATION — ARTWORK RATINGS
   Standalone storefront enhancement v1
========================================================= */
(function () {
  "use strict";

  if (window.__UNISOURCE_DESIGN_RATINGS_V1__) return;
  window.__UNISOURCE_DESIGN_RATINGS_V1__ = true;

  var CONFIG = window.UNISOURCE_DESIGN_RATINGS || {};
  var API_BASE = String(
    CONFIG.apiBase ||
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-reviews"
  ).replace(/\/+$/, "");

  var summaryCache = new Map();
  var pendingSummary = new Map();
  var activeDesign = { id: "", title: "" };

  function clean(value) {
    return String(value == null ? "" : value).trim();
  }

  function escapeHtml(value) {
    return clean(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function designIdFromCard(card) {
    if (!card) return "";
    return clean(
      card.getAttribute("data-design-id") ||
      card.getAttribute("data-slug") ||
      card.querySelector("[data-open-design]")?.getAttribute("data-open-design")
    );
  }

  function titleFromCard(card) {
    return clean(card?.querySelector(".di-design-card__title")?.textContent);
  }

  function starsText(average) {
    var rounded = Math.max(0, Math.min(5, Math.round(Number(average || 0))));
    return "★".repeat(rounded) + "☆".repeat(5 - rounded);
  }

  function summaryMarkup(summary, compact) {
    var count = Number(summary?.ratingCount || 0);
    var average = Number(summary?.averageRating || 0);
    var label = count
      ? average.toFixed(1) + " · " + count + " rating" + (count === 1 ? "" : "s")
      : "Not rated yet";

    return (
      '<span class="di-rating-summary__stars" aria-hidden="true">' +
      starsText(average) +
      "</span>" +
      '<span class="di-rating-summary__text">' +
      escapeHtml(label) +
      "</span>"
    );
  }

  async function getSummary(designId) {
    designId = clean(designId);
    if (!designId) return { designId: "", averageRating: 0, ratingCount: 0 };

    if (summaryCache.has(designId)) return summaryCache.get(designId);
    if (pendingSummary.has(designId)) return pendingSummary.get(designId);

    var request = fetch(API_BASE + "/" + encodeURIComponent(designId), {
      method: "GET",
      cache: "no-store",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(function (payload) {
        var summary = payload?.data || {
          designId: designId,
          averageRating: 0,
          ratingCount: 0
        };
        summaryCache.set(designId, summary);
        return summary;
      })
      .catch(function () {
        return { designId: designId, averageRating: 0, ratingCount: 0 };
      })
      .finally(function () {
        pendingSummary.delete(designId);
      });

    pendingSummary.set(designId, request);
    return request;
  }

  async function decorateCard(card) {
    if (!card || card.dataset.ratingReady === "true") return;

    var designId = designIdFromCard(card);
    if (!designId) return;

    card.dataset.ratingReady = "true";
    card.dataset.designRatingId = designId;

    var body = card.querySelector(".di-design-card__body");
    if (!body) return;

    var summaryEl = document.createElement("div");
    summaryEl.className = "di-rating-summary di-rating-summary--card";
    summaryEl.setAttribute("aria-label", "Artwork rating");
    summaryEl.innerHTML =
      '<span class="di-rating-summary__stars" aria-hidden="true">☆☆☆☆☆</span>' +
      '<span class="di-rating-summary__text">Loading ratings…</span>';
    body.appendChild(summaryEl);

    var summary = await getSummary(designId);
    summaryEl.innerHTML = summaryMarkup(summary, true);
  }

  function decorateCards(root) {
    (root || document)
      .querySelectorAll(".di-design-card")
      .forEach(decorateCard);
  }

  function setFormMessage(form, message, isError) {
    var target = form.querySelector("[data-rating-message]");
    if (!target) return;
    target.textContent = message || "";
    target.classList.toggle("is-error", Boolean(isError));
    target.classList.toggle("is-success", Boolean(message) && !isError);
  }

  function ratingFormMarkup(designId, title) {
    return (
      '<section class="di-rating-panel" data-rating-panel data-design-id="' +
      escapeHtml(designId) +
      '">' +
        '<div class="di-rating-panel__head">' +
          '<div>' +
            '<div class="di-visualizer__label">Rate this artwork</div>' +
            '<div class="di-rating-summary di-rating-summary--modal" data-modal-rating-summary>' +
              '<span class="di-rating-summary__stars" aria-hidden="true">☆☆☆☆☆</span>' +
              '<span class="di-rating-summary__text">Loading ratings…</span>' +
            "</div>" +
          "</div>" +
        "</div>" +
        '<form class="di-rating-form" data-rating-form>' +
          '<input type="hidden" name="designId" value="' + escapeHtml(designId) + '">' +
          '<input type="hidden" name="designTitle" value="' + escapeHtml(title) + '">' +
          '<div class="di-star-picker" role="radiogroup" aria-label="Choose a star rating">' +
            [1,2,3,4,5].map(function (value) {
              return (
                '<button type="button" class="di-star-picker__star" data-rating-value="' +
                value +
                '" role="radio" aria-checked="false" aria-label="' +
                value +
                ' star' + (value === 1 ? "" : "s") + '">★</button>'
              );
            }).join("") +
          "</div>" +
          '<input type="hidden" name="rating" value="">' +
          '<div class="di-rating-form__grid">' +
            '<label>Name <span>(optional)</span><input name="name" autocomplete="name" maxlength="160"></label>' +
            '<label>Email <span>(required, never displayed)</span><input name="email" type="email" autocomplete="email" required maxlength="254"></label>' +
            '<label class="di-rating-form__full">Comment <span>(optional; reviewed before public display)</span><textarea name="comment" rows="3" maxlength="1000"></textarea></label>' +
          "</div>" +
          '<label class="di-rating-form__consent"><input type="checkbox" name="consent" required> I agree that Unisource Apparel may save this rating and use my information to manage my submission.</label>' +
          '<label class="di-rating-form__honeypot" aria-hidden="true">Website<input name="companyWebsite" tabindex="-1" autocomplete="off"></label>' +
          '<button type="submit" class="di-rating-form__submit">Submit rating</button>' +
          '<div class="di-rating-form__message" data-rating-message role="status" aria-live="polite"></div>' +
        "</form>" +
      "</section>"
    );
  }

  async function refreshModalSummary(panel, designId) {
    var target = panel.querySelector("[data-modal-rating-summary]");
    if (!target) return;
    var summary = await getSummary(designId);
    target.innerHTML = summaryMarkup(summary, false);
  }

  function bindRatingForm(panel) {
    var form = panel.querySelector("[data-rating-form]");
    if (!form || form.dataset.bound === "true") return;
    form.dataset.bound = "true";

    var ratingInput = form.querySelector('input[name="rating"]');
    var stars = Array.from(form.querySelectorAll("[data-rating-value]"));

    function selectRating(value) {
      ratingInput.value = String(value);
      stars.forEach(function (star) {
        var starValue = Number(star.dataset.ratingValue);
        var selected = starValue <= value;
        star.classList.toggle("is-selected", selected);
        star.setAttribute(
          "aria-checked",
          starValue === value ? "true" : "false"
        );
      });
      setFormMessage(form, "", false);
    }

    stars.forEach(function (star) {
      star.addEventListener("click", function () {
        selectRating(Number(star.dataset.ratingValue));
      });
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      var rating = Number(ratingInput.value);
      if (!rating) {
        setFormMessage(form, "Choose a rating from 1 to 5 stars.", true);
        stars[0]?.focus();
        return;
      }

      if (!form.reportValidity()) return;

      var submit = form.querySelector(".di-rating-form__submit");
      submit.disabled = true;
      submit.textContent = "Saving…";
      setFormMessage(form, "", false);

      var data = new FormData(form);
      var payload = {};
      data.forEach(function (value, key) {
        payload[key] = String(value);
      });
      payload.rating = rating;

      var designId = clean(payload.designId);

      try {
        var response = await fetch(
          API_BASE + "/" + encodeURIComponent(designId),
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          }
        );

        var result = await response.json().catch(function () { return {}; });
        if (!response.ok || result.success !== true) {
          throw new Error(result.error || "Unable to save your rating.");
        }

        var summary = result?.data?.summary;
        if (summary) summaryCache.set(designId, summary);

        setFormMessage(form, result.message || "Thank you for your rating.", false);
        submit.textContent = "Rating saved";

        document
          .querySelectorAll('.di-design-card[data-design-rating-id="' + CSS.escape(designId) + '"] .di-rating-summary')
          .forEach(function (element) {
            element.innerHTML = summaryMarkup(summary, true);
          });

        var modalSummary = panel.querySelector("[data-modal-rating-summary]");
        if (modalSummary && summary) {
          modalSummary.innerHTML = summaryMarkup(summary, false);
        }
      } catch (error) {
        setFormMessage(form, error.message || "Unable to save your rating.", true);
        submit.disabled = false;
        submit.textContent = "Submit rating";
      }
    });
  }

  function decorateModal() {
    var root = document.querySelector("#di-modal [data-visualizer-root]");
    if (!root || root.querySelector("[data-rating-panel]")) return;

    var panel = root.querySelector(".di-visualizer__panel");
    if (!panel) return;

    var title = clean(panel.querySelector("h2")?.textContent) || activeDesign.title;
    var designId = activeDesign.id;

    if (!designId) {
      var matchingCard = Array.from(document.querySelectorAll(".di-design-card"))
        .find(function (card) {
          return titleFromCard(card) === title;
        });
      designId = designIdFromCard(matchingCard);
    }

    if (!designId) return;

    var wrapper = document.createElement("div");
    wrapper.innerHTML = ratingFormMarkup(designId, title);
    var ratingPanel = wrapper.firstElementChild;

    var actions = panel.querySelector(".di-visualizer__actions");
    if (actions) actions.insertAdjacentElement("beforebegin", ratingPanel);
    else panel.appendChild(ratingPanel);

    bindRatingForm(ratingPanel);
    refreshModalSummary(ratingPanel, designId);
  }

  document.addEventListener(
    "click",
    function (event) {
      var opener = event.target.closest("[data-open-design]");
      if (opener) {
        var card = opener.closest(".di-design-card");
        activeDesign = {
          id: clean(opener.getAttribute("data-open-design")) || designIdFromCard(card),
          title: titleFromCard(card)
        };
      }
    },
    true
  );

  var observer = new MutationObserver(function () {
    decorateCards(document);
    decorateModal();
  });

  function init() {
    decorateCards(document);
    decorateModal();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
